export const BODY_METRIC_KEYS = ["height", "weight", "leanBodyMass", "bodyFatPercentage"] as const;

export type BodyMetricKey = (typeof BODY_METRIC_KEYS)[number];

export const BODY_METRIC_GROUP_TYPES = ["weight", "body-composition"] as const;

export type BodyMetricGroupType = (typeof BODY_METRIC_GROUP_TYPES)[number];
